export const languages = [
  { id: 'pl', name: 'PL' },
  { id: 'en', name: 'EN' },
  { id: 'uk', name: 'UK' },
  { id: 'ru', name: 'RU' },
]
